import { useState } from 'react';
import Header from '../components/layout/Header.jsx';
import { useObjetivo, useUpsertObjetivo } from '../features/objetivos/useObjetivos.js';

export default function ObjetivosPage() {
  const now = new Date();
  const [mes, setMes] = useState(now.getMonth() + 1);
  const [anio, setAnio] = useState(now.getFullYear());

  const { data: objetivo, isLoading } = useObjetivo(mes, anio);
  const upsert = useUpsertObjetivo();

  function handleSubmit(e) {
    e.preventDefault();
    const valor_global = parseInt(e.target.valor_global.value);
    upsert.mutate({ mes, anio, valor_global });
  }

  return (
    <div>
      <Header title="Objetivos" />
      <div className="p-6 max-w-xl">
        <div className="bg-white rounded-lg border border-gray-100 shadow-sm p-6 flex flex-col gap-6">

          {/* Selector mes/año */}
          <div className="flex gap-3">
            <select
              value={mes}
              onChange={(e) => setMes(parseInt(e.target.value))}
              className="border border-gray-200 rounded-md px-3 py-2 text-sm font-['Inter']"
            >
              {['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'].map((m, i) => (
                <option key={i} value={i + 1}>{m}</option>
              ))}
            </select>
            <input
              type="number"
              value={anio}
              onChange={(e) => setAnio(parseInt(e.target.value))}
              className="border border-gray-200 rounded-md px-3 py-2 text-sm font-['Inter'] w-24"
            />
          </div>

          {/* Info actual */}
          {!isLoading && objetivo && (
            <div className="grid grid-cols-3 gap-4 text-center">
              <div>
                <p className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">Objetivo global</p>
                <p className="font-['Raleway'] font-bold text-[#0D2B5C] text-2xl mt-1">{objetivo.valor_global}</p>
              </div>
              <div>
                <p className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">Por vendedor</p>
                <p className="font-['Raleway'] font-bold text-[#0D2B5C] text-2xl mt-1">{objetivo.valor_por_vendedor}</p>
              </div>
              <div>
                <p className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">Vendedores activos</p>
                <p className="font-['Raleway'] font-bold text-[#0D2B5C] text-2xl mt-1">{objetivo.vendedoresActivos}</p>
              </div>
            </div>
          )}

          {/* Formulario edición */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-3">
            <label className="font-['Raleway'] text-[#1E9BE8] text-xs font-semibold tracking-widest uppercase">
              Nuevo objetivo global
            </label>
            <input
              name="valor_global"
              type="number"
              min="1"
              defaultValue={objetivo?.valor_global ?? ''}
              className="border border-gray-200 rounded-md px-3 py-2 text-sm font-['Inter']"
              placeholder="Ej: 120"
            />
            <button
              type="submit"
              disabled={upsert.isPending}
              className="bg-[#1E9BE8] hover:bg-[#1780C5] text-white font-['Raleway'] font-bold text-sm px-6 py-3 rounded-md transition-colors min-h-[44px] disabled:opacity-50"
            >
              {upsert.isPending ? 'Guardando...' : 'Guardar objetivo'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
